export default {
      id: "xLogo-usage",
      viewBox: "0 0 37 36",
      url: __webpack_public_path__ + "sprite.svg#xLogo",
      toString: function () {
        return this.url;
      }
    }